import {observer} from 'mobx-react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import HrEmployeeProfileSwitch from './HrEmployeeProfileSwitch';
import {EmployeeProfileState} from '../state';
import {withState} from 'shared/core';

const EmployeePage = observer(() => {
  return (
    <Router basename='/employees'>
      <Route path='/:id' component={withState(HrEmployeeProfileSwitch, EmployeeProfileState)} />
    </Router>
  );
});

export default EmployeePage;
